// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a08052c6cfd09b8cbe19","655":"91563336b56d316b805d"}[chunkId] + ".js";
};